import { STEP_TYPES } from '@highlight-cp/constants';
import type { StepBase } from '@highlight-cp/project-api';

/**
 * Returns the effective duration for a fielding step. For group steps, uses the highest
 * duration among `groupedSteps` (same rule as instructions step badges and review).
 */
export const getStepDuration = (step: StepBase): number => {
  // duration is not set on a group step, so we need to compute the max duration of the grouped steps
  if (step.type === STEP_TYPES.GROUP) {
    const durations = step.groupedSteps?.map((groupedStep) => groupedStep.duration ?? 0) ?? [];

    return Math.max(0, ...durations);
  }

  return step.duration ?? 0;
};
